import Vue from 'vue';
import PageTitleImage from "./Libraries/PageTitleImage";
import AppError from "./Libraries/AppError";
import GA4 from "./Libraries/GA4";
import PageHeader from "./Libraries/PageHeader";

Vue.prototype.$pageTitleImage = new PageTitleImage;
Vue.prototype.$pageHeader = new PageHeader;
Vue.prototype.$appError = new AppError;
Vue.prototype.$GA4 = new GA4;
